var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcFxs32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3531_6627)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3531_6627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 31.9653C24.8173 31.9653 31.9653 24.8174 31.9653 16C31.9653 7.18263 24.8173 0.034729 16 0.034729C7.18257 0.034729 0.034668 7.18263 0.034668 16C0.034668 24.8174 7.18257 31.9653 16 31.9653Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.64978
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92415 6.90177L7.85376 7.97215L9.208 9.3264L10.5652 10.6806L10.4528 11.0118C10.308 11.4465 10.2488 11.8102 10.2488 12.2921C10.2488 13.8622 11.0708 15.1987 12.5256 15.9941C13.1111 16.3135 14.1164 16.6742 15.2311 16.961C17.4074 17.5199 17.7415 17.6174 18.1702 17.8185C18.7557 18.0964 19.0455 18.398 19.1667 18.8534C19.2199 19.0515 19.217 19.495 19.1638 19.7079C19.0277 20.2254 18.5872 20.7458 18.0401 21.0296C17.3009 21.417 16.0147 21.5234 15.0448 21.2751C14.6841 21.1864 14.1726 20.935 13.9153 20.7251C13.392 20.2934 12.9839 19.5483 12.8035 18.6878C12.774 18.5518 12.7503 18.4365 12.7474 18.4306C12.7385 18.4187 9.71067 18.7144 9.69588 18.7322C9.68405 18.741 9.69293 18.8652 9.71363 19.0072C9.80825 19.6902 10.0478 20.5033 10.3227 21.0681L10.4824 21.3963L9.16661 22.7121L7.85376 24.0279L8.9271 25.1012L9.99748 26.1716L11.3547 24.8144L12.7089 23.4602L12.9425 23.5578C14.1785 24.0782 16.0324 24.2408 17.8302 23.9806C18.2619 23.9185 18.8858 23.7707 19.214 23.6494L19.4092 23.5785L20.7072 24.8765L22.0023 26.1716L23.0727 25.1012L24.1461 24.0279L22.9426 22.8245L21.7421 21.624L21.8929 21.3165C22.2064 20.6867 22.3365 20.1515 22.3631 19.4152C22.4104 18.0107 22.0467 16.9521 21.2188 16.0799C20.3554 15.1721 19.3826 14.7404 16.6356 14.0485C14.6989 13.5636 13.8651 13.2295 13.5339 12.8096C13.2057 12.3956 13.1761 11.8161 13.4629 11.3932C13.6285 11.1478 14.0366 10.8847 14.4801 10.7368C14.9798 10.5683 15.8195 10.4914 16.4434 10.5564C17.7592 10.6954 18.4216 11.2572 18.7114 12.4873C18.7468 12.6381 18.7794 12.7652 18.7823 12.7711C18.7882 12.78 20.929 12.7031 21.5706 12.6706L21.9373 12.6529L21.9166 12.3956C21.8752 11.8723 21.7717 11.4051 21.5825 10.9172L21.479 10.6422L22.8125 9.3057L24.1461 7.97215L23.0757 6.89881L22.0023 5.82843L20.654 7.17676L19.3027 8.52804L18.9745 8.40386C18.1673 8.10226 17.3867 7.9692 16.2365 7.93667C14.9798 7.90415 13.8769 8.06677 13.0312 8.40977L12.7178 8.53691L11.3576 7.18267L9.99748 5.82843L8.92415 6.90177Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3531_6627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3531_6627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFxs32);
export default __webpack_public_path__ + "static/media/ic_fxs_32.f10d84d8a4cf80f3fd6fa0219a019ead.svg";
export { ForwardRef as ReactComponent };